import { useState } from 'react'
import DocLayout from '../components/docs/DocLayout'
import PatternCard from '../components/docs/PatternCard'
import Icon from '../components/docs/Icon'
import { patterns } from '../content/system'
import Cased from '@/components/ui/Cased'
export default function PatternsPage() {
  const [query, setQuery] = useState('')
  const [category, setCategory] = useState('All patterns')
  const filtered = patterns.filter(
    (pattern) =>
      (category === 'All patterns' || pattern.category === category) &&
      `${pattern.title} ${pattern.summary} ${pattern.category}`
        .toLowerCase()
        .includes(query.trim().toLowerCase()),
  )
  return (
    <DocLayout
      eyebrow="Patterns"
      title="Patterns for the mission."
      intro="Complete workflows assembled from MDS components: dashboards, review queues, guided intake, records and cited answers. Read the guidance, try the interaction, then build your own."
      wide
    >
      <div className="pat-catalog-controls">
        <div className="mds-prompt pat-search">
          <Icon name="search" size={19} />
          <label className="mds-visually-hidden" htmlFor="pattern-search">
            Search patterns
          </label>
          <input
            id="pattern-search"
            type="search"
            className="mds-prompt__input"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Find a pattern, task or workflow"
          />
        </div>
        <div className="mds-segmented" role="group" aria-label="Pattern category">
          {['All patterns', 'Operations', 'Transactions', 'Intelligence'].map(
            (value) => (
              <button
                key={value}
                type="button"
                className="mds-segmented__option"
                aria-pressed={category === value}
                onClick={() => setCategory(value)}
              >
                {value}
              </button>
            ),
          )}
        </div>
      </div>
      <p className="pat-status" role="status">
        {filtered.length} {filtered.length === 1 ? 'pattern' : 'patterns'}
        {category === 'All patterns'
          ? ' for mission work'
          : ` in ${category.toLowerCase()}`}
      </p>
      <h2 className="mds-visually-hidden"><Cased>Available patterns</Cased></h2>
      <div className="pat-grid">
        {filtered.map((pattern) => (
          <PatternCard key={pattern.id} pattern={pattern} />
        ))}
      </div>
      {filtered.length === 0 && (
        <div className="pat-empty">
          <span className="pat-empty__icon">
            <Icon name="search" size={30} />
          </span>
          <h2 className="mds-h3"><Cased>No matching patterns</Cased></h2>
          <p className="mds-muted">
            Try another phrase or clear the filters to see the full library.
          </p>
          <button
            type="button"
            className="mds-button mds-button--secondary"
            onClick={() => {
              setQuery('')
              setCategory('All patterns')
            }}
          >
            Clear filters
          </button>
        </div>
      )}
      <aside className="doc-callout">
        <p className="doc-callout__title">A pattern is more than a screen.</p>
        <p>
          Each pattern includes the context, anatomy, interaction requirements
          and acceptance checks that make it useful in a real workflow.
        </p>
      </aside>
    </DocLayout>
  )
}
